import { HOST, API_URL } from 'tenant/host_config';
import { IS_TENANT } from 'tenant/utils';

const config = {
  HOST,
  IS_TENANT,
  DEBUG: process.env.NODE_ENV === 'development',
  API_URL,
  ONTRUCK_AUTH_CLIENTID: process.env.REACT_APP_ONTRUCK_AUTH_CLIENTID,
  GIS_URL: process.env.REACT_APP_GIS_URL,
  GOOGLE_KEY:
    process.env.NODE_ENV === 'development'
      ? 'AIzaSyAbWx0_pC0j-XbtPHnyKNSFwyvCPUBBi9I'
      : 'AIzaSyCv1KtYJ_A22IKK6VwbQRd_zP3SzcH7bls',
  DEFAULT_STRIPE_KEY: process.env.REACT_APP_STRIPE_KEY,
  STRIPE_KEY: {
    ES: process.env.REACT_APP_STRIPE_KEY,
    UK: process.env.REACT_APP_STRIPE_KEY_UK,
    FR: process.env.REACT_APP_STRIPE_KEY_FR,
    NL: process.env.REACT_APP_STRIPE_KEY_NL,
  },
  WS_URL: process.env.REACT_APP_WS_URL,
  APP_VERSION: process.env.REACT_APP_VERSION,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  ENVIRONMENT: process.env.REACT_APP_ENV,
  OFFER_LINKS: {
    ES: 'https://info.ontruck.com/hubfs/Cobertura%20geogr%C3%A1fica/2022%20Cobertura%20geogr%C3%A1fica%20servicios%20ES.pdf',
    FR: 'https://info.ontruck.com/hubfs/Cobertura%20geogr%C3%A1fica/2023%20Couverture%20G%C3%A9ographique%20FR.pdf',
    UK: '',
    NL: '',
  },
  LH_EXPRESS_LINK:
    'https://info.ontruck.com/hubfs/Sales%20Collaterals/One%20Pagers/es-one-pager-LH-ontruck-2022.pdf',
  REFINER: {
    PROJECT_ID: 'd18411b0-fc00-11ea-8c74-01d84c66ce23',
  },
  POI_ADDRESS_URL: process.env.REACT_APP_POI_ADDRESS_URL,
  POI_ADDRESS_PARSER_URL: process.env.REACT_APP_POI_ADDRESS_PARSER_URL,
  SUPERSET_URL: process.env.REACT_APP_SUPERSET_URL,
  SUPERSET_TOKEN: process.env.REACT_APP_SUPERSET_TOKEN,
};

export default config;
